// extracted by mini-css-extract-plugin
export default {"bullet_point":"issues-list_bullet_point__0S0Lm"};